import keys from '../../../../config/keys';

export default {
  10009: keys.BACK,
  13: keys.ENTER,
  '-1': keys.EXIT,

  38: keys.UP,
  40: keys.DOWN,
  37: keys.LEFT,
  39: keys.RIGHT,

  // Color
  403: keys.RED,
  404: keys.GREEN,
  405: keys.YELLOW,
  406: keys.BLUE,

  428: keys.CH_UP,
  427: keys.CH_DOWN,

  // Playback
  415: keys.PLAY,
  19: keys.PAUSE,
  10252: keys.PLAY_PAUSE,
  412: keys.RW,
  417: keys.FF,
  413: keys.STOP,
  424: keys.PREV_TRACK,
  425: keys.NEXT_TRACK,

  // Numeric
  49: keys.ONE,
  50: keys.TWO,
  51: keys.THREE,
  52: keys.FOUR,
  53: keys.FIVE,
  54: keys.SIX,
  55: keys.SEVEN,
  56: keys.EIGHT,
  57: keys.NINE,
  48: keys.ZERO,
};
